import z from 'zod';
var fragment = {
    type: 'image',
    validation: function validation(Rule) {
        return Rule.custom(function(value) {
            if (!value || !value.asset) return 'Image is required';
            return true;
        });
    },
    options: {
        metadata: [
            'lqip',
            'palette',
            'exif'
        ],
        storeOriginalFilename: true
    }
};
var validator = z.object({
    _type: z.literal('image')
}).passthrough().refine(function(value) {
    return true;
});
export default {
    fragment: fragment,
    validator: validator
};

//# sourceMappingURL=requiredImage.js.map